module.exports = __webpack_public_path__ + "img/wyszukiwanie.b980eacc.svg";